import ChipOptional from "../Chip/ChipOptional";
import { useTranslationApp } from "../../lib/i18next";
import {
  BRAND_INSIGHTS_UNREAD_ONE,
  BRAND_INSIGHTS_UNREAD_OTHER,
} from "../../i18n/keysTranslations";

const BrandInsightsUnreadBadge = ({ count }) => {
  const { t } = useTranslationApp();

  if (!count) {
    return null;
  }

  const displayCount = count > 99 ? "99+" : count;
  const label =
    count === 1
      ? t(BRAND_INSIGHTS_UNREAD_ONE)
      : t(BRAND_INSIGHTS_UNREAD_OTHER, { count: displayCount });

  return (
    <ChipOptional
      size="small"
      label={label}
      sx={{
        height: 18,
        fontSize: "10px !important",
        fontWeight: 500,
        color: "text.primary",
        "& .MuiChip-label": {
          px: 0.75,
          py: 0,
        },
      }}
    />
  );
};

export default BrandInsightsUnreadBadge;
